var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner_app"},[_c('div',{ref:"wrapfirfin",class:['wrap_firfin', _vm.pageClassName],attrs:{"id":"firfinWrap"}},[_c('Header',{attrs:{"isScrolled":_vm.isScrolled}}),_c('Content',[_vm._t("default")],2),_c('Footer')],1),_vm._t("popup")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }